import { ServiceResult } from '../models';
import { GetRecipeDiariesRequest, RecipeDiary } from '../models/recipe-diary.models';
import ApiService from './api-service';

class RecipeDiaryService extends ApiService {
  private static classInstance: RecipeDiaryService;

  private constructor() {
    super('RecipeDiary');
  }

  public static getInstance(): RecipeDiaryService {
    if (!this.classInstance) {
      this.classInstance = new RecipeDiaryService();
    }
    return this.classInstance;
  }

  public getRecipeDiary(recipeDiaryId: string): ServiceResult<RecipeDiary> {
    return this.get(`${this.persistUrl}/GetRecipeDiary?recipeDiaryId=${recipeDiaryId}`);
  }

  public getRecipeDiarys(request: GetRecipeDiariesRequest): ServiceResult<RecipeDiary[]> {
    return this.post(`${this.persistUrl}/GetRecipeDiarys`, request);
  }
}

export default RecipeDiaryService;
